import { useUserContext } from '../../Contexts/UserConfig'
import { useMessagePopupContext } from '../../garvan-react/Components/ModalFeedback/MessagePopup'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { AxiosResponse } from 'axios'
import PhpAPI from '../PHP/APIs/PhpAPI'
import { useNavigate } from 'react-router-dom'
import { useVesselContext } from '../../Contexts/Modules/SampleModule/VesselModule'

export function useVesselOpen(
  holding_id: string | number | undefined,
  vessel_id: string | number | undefined,
) {
  const { whoAmI } = useUserContext()
  const { setError, setMessage } = useMessagePopupContext()
  const navigate = useNavigate()
  return useMutation<any, AxiosResponse, 'vessel' | 'holding', () => void>(
    (type) => {
      let filter = ''
      if (type === 'holding') {
        filter = 'HoldingID=' + holding_id
      } else {
        filter = 'VesselID=' + vessel_id
      }
      return PhpAPI.get(whoAmI!, '/stuart/vessel/getVessel.php?' + filter)
    },
    {
      onError: (err) => setError(err),
      onSuccess: (data, type) => {
        if (data?.VesselID) {
          if (type === 'holding') {
            navigate('../holding/' + holding_id)
          } else {
            navigate('../info/' + vessel_id)
          }
        } else if (data?.message) {
          setMessage({
            subject: 'Error',
            severity: 'warning',
            message: data.message,
          })
        } else {
          setMessage({
            subject: 'Error',
            severity: 'warning',
            message: 'Response did not return expected result',
          })
        }
      },
    },
  )
}

export function useVesselGet(
  vessel_id: string | undefined,
  enabled: boolean,
  holding_id?: string,
) {
  const { whoAmI } = useUserContext()
  const { setError, setMessage } = useMessagePopupContext()
  let filter = ''
  if (holding_id) {
    filter = 'HoldingID=' + holding_id
  } else {
    filter = 'VesselID=' + vessel_id
  }
  return useQuery<any, AxiosResponse>(
    ['PhpAPI', '/stuart', '/vessel/getVessel.php', holding_id, vessel_id],
    (type) => PhpAPI.get(whoAmI!, '/stuart/vessel/getVessel.php?' + filter),
    {
      enabled: (!!vessel_id || !!holding_id) && enabled,
      onError: (err) => setError(err),
      onSuccess: (data) => {
        if (!data?.VesselID) {
          setMessage({
            subject: 'Error getting vessel information',
            message: (data as any)?.message,
            severity: 'warning',
          })
        }
      },
    },
  )
}

export function useVesselMove(to_vessel: string | undefined, setMoveData: any) {
  const { whoAmI } = useUserContext()
  const queryClient = useQueryClient()
  const { setError, setMessage } = useMessagePopupContext()
  const { setFields } = useVesselContext()
  return useMutation<
    any,
    AxiosResponse,
    {
      move_vessel: string | undefined
      new_pos?: number
    },
    () => void
  >(
    ({ move_vessel, new_pos }) => {
      let confirm = ''
      if (new_pos !== undefined) {
        confirm = `&NewPos=${new_pos}&Confirm=true`
      }
      return PhpAPI.get(
        whoAmI!,
        `/stuart/vessel/moveVessel.php?ToVesselID=${to_vessel}&VesselID=${move_vessel}` +
          confirm,
      )
    },
    {
      onError: (err) => setError(err),
      onSuccess: async (data) => {
        if (data?.Vessel) {
          setMoveData(data)
        } else if (data?.Success) {
          setMoveData(undefined)
          setFields({})
          await queryClient.invalidateQueries({
            queryKey: ['PhpAPI', '/stuart', '/vessel/getVessel.php'],
          })
        } else {
          setMessage({
            subject: 'Error',
            severity: 'warning',
            message:
              data?.message ?? 'An unexpected error occurred moving the vessel',
          })
        }
      },
    },
  )
}

export function useVesselNew(
  vesselLocation: string | number,
  vesselType: string | number,
  vesselID: string | undefined,
) {
  const { whoAmI } = useUserContext()
  const { setError } = useMessagePopupContext()
  const navigate = useNavigate()
  let vesselPath = ''
  if (vesselID) {
    vesselPath = `&VesselID=${vesselID}`
  }
  return useMutation<any, AxiosResponse>(
    () =>
      PhpAPI.get(
        whoAmI!,
        `/stuart/vessel/newVessel.php?HoldingID=${vesselLocation}&VesselType=${vesselType}` +
          vesselPath,
      ),
    {
      onError: (err) => setError(err),
      onSuccess: (data) => {
        if (data?.VesselID) {
          navigate('/stuart/sample/vessel/info/' + data.VesselID)
        }
      },
    },
  )
}
